<template>
    <v-row align="center">
        <v-col class="waiting text-center">
            <img src="@/assets/images/waiting-icon.png" alt="">
            <h1>{{ message }}</h1>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: ["message"],
        name: "RomaWait"
    }
</script>

<style lang="scss">
    .waiting {
        margin-top: 40vh;
    h1 {
        font-family: "Cabin", Regular, serif;
        font-weight: normal;
        font-size: 20px;
        margin-bottom: 50px;
        margin-top: 30px;
        }
    }
</style>